// components/invoices/CustomerSearch.js
import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs, limit } from "firebase/firestore";
import { db } from '../../services/firebase';
import styles from './Invoices.module.css';

const CustomerSearch = ({ selectedCustomer, setSelectedCustomer, jewellerId }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  // Customer search effect
  useEffect(() => {
    if (!searchQuery.trim() || !jewellerId || selectedCustomer) {
      setSearchResults([]);
      return;
    }
  
    const debounceTimer = setTimeout(async () => {
      setIsSearching(true);
      
      const lowerCaseQuery = searchQuery.toLowerCase();
      
      const q = query(
        collection(db, 'users'),
        where('name_lowercase', '>=', lowerCaseQuery),
        where('name_lowercase', '<=', lowerCaseQuery + '\uf8ff'),
        limit(10)
      );
      
      try {
        const querySnapshot = await getDocs(q);
        const users = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        // Filter users to only include those who have projects with this jeweller
        const filteredUsers = [];
        
        for (const user of users) {
          const projectsQuery = query(
            collection(db, 'projects'),
            where('userId', '==', user.id),
            where('jewellerId', '==', jewellerId),
            limit(1)
          );
          
          const projectsSnapshot = await getDocs(projectsQuery);
          if (!projectsSnapshot.empty) {
            filteredUsers.push(user);
          }
        }
        
        setSearchResults(filteredUsers);
      } catch (error) {
        console.error("Error searching users:", error);
      } finally {
        setIsSearching(false);
      }
    }, 500);
  
    return () => clearTimeout(debounceTimer);
  }, [searchQuery, jewellerId, selectedCustomer]);

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    setSearchQuery('');
    setSearchResults([]);
  };

  const handleClearCustomer = () => {
    setSelectedCustomer(null);
  };

  return (
    <div className={styles.customerSearch}>
      {selectedCustomer ? (
        <div className={styles.selectedCustomer}>
          <span className={styles.selectedCustomerText}>
            Filtering by: {selectedCustomer.name}
          </span>
          <button 
            onClick={handleClearCustomer} 
            className={styles.clearBtn}
            aria-label="Clear customer filter"
          >
            ×
          </button>
        </div>
      ) : (
        <div className={styles.searchWrapper}>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={styles.searchInput}
            placeholder="Search by customer name..."
          />
          {isSearching && <p className={styles.searchStatus}>Searching...</p>}
          
          {searchResults.length > 0 && (
            <ul className={styles.searchResults}>
              {searchResults.map(customer => (
                <li 
                  key={customer.id} 
                  onClick={() => handleSelectCustomer(customer)}
                  className={styles.searchResultItem}
                >
                  {customer.name} ({customer.email})
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomerSearch;